<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-overlay :value="updating">
        {{updating}}
      </v-overlay>
      <v-container>
        <v-alert v-if="isLive" type="info" dense> 퍼지 목록 퍼지 -> 데이터 수정 -> 디자인 적용</v-alert>
      </v-container>
      <!-- <v-btn v-if="!isLive" color="primary" dark class="mb-2" @click="meta_update">메타 파일 서버 적용</v-btn>
      <v-btn v-if="isLive" color="primary" dark class="mb-2" @click="meta_update_live">메타 파일 서버 적용(Live)</v-btn> -->

      <v-tabs
        fixed-tabs
        background-color="indigo"
        dark
      >
        <v-tab v-for="tab_item in tabs" :key="tab_item.seq" @click.prevent="get_tab_link(tab_item)">
          {{tab_item.title}}
        </v-tab>
      </v-tabs>
      <router-view></router-view>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../../src/config/config';
import store from '../../store';
// var dateFormat = require('dateformat');
// const {s3_upload, readFileAsync, exportTxt, exportPurgeTxt} = require("../util/fileutil");
export default {
  name: '',
  created() {      
  },
  computed: {
    isLive(){
      return config.isLive;
    },
  },
  methods: {
    ...mapActions([
    ]),
    get_tab_link(tab_item) {
      this.$router.push(`/cms_user_tab/${tab_item.path}`);
    },
  },
  data() {
    return {
      updating: "",
      tabs: [ //      this.$router.push(`/template_tab/event_home`);
        {type: "cms_user_managed_home", title: "템플릿 관리 홈", path:"cms_user_managed_home"},        
      ],
    }
  }
};
</script>
